import { styled } from '@clickcease/cc-client-components-lib'

export const CustomersStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
})

export const CustomersTextWrapper = styled('div', {
  fontWeight: '$b',
  fontSize: '40px',
  width: '100%',
  display: 'flex',

  justifyContent: 'center',
})

export const CustomersText = styled('div', {
  width: '710px',
  margin: '80px 0px 60px 0px',

  '@bp1': {
    width: '90%',
    fontSize: '$h1',
    textAlign: 'center',
  },
})

export const CustomersTextCheq = styled('span', {
  color: '$primaryColor',
})
